export default {
  sizes: ['small', 'medium', 'large', 'xlarge', 'other'],
  vase_colors: [
    'white',
    'black',
    'grey',
    'red',
    'green',
    'blue',
    'orange',
    'yellow',
    'silver',
    'gold',
    'brown',
    'purple',
    'pink',
  ],
  flower_colors: [
    'white',
    'black',
    'grey',
    'red',
    'green',
    'blue',
    'orange',
    'yellow',
    'silver',
    'gold',
    'brown',
    'purple',
    'pink',
  ],
};
